import { render, staticRenderFns } from "./PageAttributes.vue?vue&type=template&id=1ec7a9c4&"
import script from "./PageAttributes.vue?vue&type=script&lang=js&"
export * from "./PageAttributes.vue?vue&type=script&lang=js&"
import style0 from "./PageAttributes.vue?vue&type=style&index=0&id=1ec7a9c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports